<ng-container [ngSwitch]="variant">
  <div *ngSwitchCase="'entity-list'" class="content-skeleton content-skeleton-entity-list">
    <div
      *ngIf="showHeader"
      class="content-skeleton-entity-header"
      [style.grid-template-columns]="gridTemplateColumns"
    >
      <span
        *ngFor="let _ of columnArray; let i = index"
        class="content-skeleton-block content-skeleton-header-block"
        [style.width.%]="i === 0 ? 72 : 58"
      ></span>
    </div>

    <div class="content-skeleton-entity-body">
      <div
        *ngFor="let _ of itemArray; let itemIndex = index"
        class="content-skeleton-entity-card"
        [style.grid-template-columns]="gridTemplateColumns"
      >
        <div *ngFor="let __ of columnArray; let columnIndex = index" class="content-skeleton-entity-cell">
          <span
            class="content-skeleton-block"
            [style.width.%]="columnIndex === 0 ? 84 : ((itemIndex + columnIndex) % 3 === 0 ? 66 : 78)"
          ></span>
          <span
            *ngIf="showSecondaryLine(columnIndex)"
            class="content-skeleton-block content-skeleton-sub-block"
            [style.width.%]="columnIndex === 0 ? 56 : 42"
          ></span>
        </div>
      </div>
    </div>
  </div>

  <div *ngSwitchCase="'stats'" class="content-skeleton content-skeleton-stats-grid">
    <div *ngFor="let _ of itemArray; let i = index" class="content-skeleton-stats-card">
      <span class="content-skeleton-block content-skeleton-label-block" [style.width.%]="58 + ((i % 2) * 12)"></span>
      <span class="content-skeleton-block content-skeleton-value-block" [style.width.%]="44 + ((i % 3) * 8)"></span>
      <span class="content-skeleton-block content-skeleton-sub-block" [style.width.%]="62"></span>
    </div>
  </div>

  <div *ngSwitchCase="'table'" class="content-skeleton content-skeleton-table">
    <div
      *ngIf="showHeader"
      class="content-skeleton-table-row content-skeleton-table-header"
      [style.grid-template-columns]="gridTemplateColumns"
    >
      <span
        *ngFor="let _ of columnArray; let i = index"
        class="content-skeleton-block content-skeleton-header-block"
        [style.width.%]="i === 0 ? 78 : 60"
      ></span>
    </div>

    <div
      *ngFor="let _ of rowArray; let rowIndex = index"
      class="content-skeleton-table-row"
      [style.grid-template-columns]="gridTemplateColumns"
    >
      <span
        *ngFor="let __ of columnArray; let columnIndex = index"
        class="content-skeleton-block"
        [style.width.%]="columnIndex === 0 ? 84 : ((rowIndex + columnIndex) % 3 === 0 ? 58 : 72)"
      ></span>
    </div>
  </div>

  <div *ngSwitchCase="'pills'" class="content-skeleton content-skeleton-pill-grid">
    <span
      *ngFor="let _ of itemArray; let i = index"
      class="content-skeleton-pill"
      [style.width.%]="18 + ((i % 3) * 2)"
    >
      <span class="content-skeleton-block"></span>
    </span>
  </div>

  <div *ngSwitchCase="'chart'" class="content-skeleton content-skeleton-chart">
    <div class="content-skeleton-chart-bars">
      <div *ngFor="let _ of itemArray; let i = index" class="content-skeleton-chart-item">
        <span class="content-skeleton-block content-skeleton-chart-value"></span>
        <div class="content-skeleton-chart-track">
          <span
            class="content-skeleton-chart-bar"
            [style.height.%]="32 + ((i * 11) % 52)"
          ></span>
        </div>
        <span class="content-skeleton-block content-skeleton-chart-label"></span>
      </div>
    </div>
    <span class="content-skeleton-block content-skeleton-chart-footer"></span>
  </div>
</ng-container>
